import { format } from "date-fns";

const formattedDate = (date, dateFormat) => {
    const formattedDate = format(date, dateFormat);
    return formattedDate;
};

export { formattedDate };